import { Action } from "@reduxjs/toolkit";

/*
 * Note: This reducer breaks convention on how reducers should be setup.
 */
export const initialState: { [key: string]: boolean } = {};

export default function requestingReducer(
  state = initialState,
  action: Action
) {
  // Action is only async if it contains one `pending` `fulfilled` or `rejected`
  const isRequestType =
    action.type.includes("pending") ||
    action.type.includes("fulfilled") ||
    action.type.includes("rejected");

  if (isRequestType === false) {
    return state;
  }

  // Remove the status of the action from the type
  let splitRequestName: String[] = action.type.split("/");
  splitRequestName.pop();
  const requestName = splitRequestName.join("/");

  // If the action type includes 'fulfilled' or 'rejected. The boolean value will be false. Otherwise we
  // assume it is a starting request and will be set to true.
  const isFinishedRequestType =
    action.type.includes("fulfilled") || action.type.includes("rejected");

  return {
    ...state,
    [requestName]: isFinishedRequestType === false,
  };
}
